import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Banner1 from "../assets/banner/banner1.jpg";
import Banner2 from "../assets/banner/banner2.jpg";

import VisionImg from "../assets/vision.jpg";
import MissionImg from "../assets/mission.jpg";
import GoalImg from "../assets/goal.jpg";

const Home = () => {
  return (
    <>
      <style>{`
        .home {
          font-family: Arial, sans-serif;
        }

        /* 🔷 BANNER */
        .banner {
          width: 100%;
          height: 500px;
        }

        .banner-img {
          width: 100%;
          height: 500px;
          object-fit: cover;
        }

        .banner-overlay {
          position: relative;
        }

        .banner-text {
          position: absolute;
          top: 80%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          text-align: center;
          background: rgba(0,0,0,0.4);
          padding: 5px 10px;
          border-radius: 6px;
        }

        /* 🔷 HERO */
        .hero {
          text-align: center;
          padding: 50px 20px;
          background: #f5f6fa;
          color: #1E3A8A
        }

        .hero h1 {
          font-size: 32px;
          margin-bottom: 10px;
        }

        .hero p {
          color: #555;
          max-width: 700px;
          margin: auto;
        }

        /* 🔷 SECTION */
        .section {
          padding: 50px 20px;
          max-width: 1100px;
          margin: auto;
        }

        /* 🔷 WRAPPER */
        .mv-wrapper {
          display: flex;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          background: white;
        }

        /* 🔷 LEFT SIDE WITH IMAGE */
        .mv-left {
  width: 120px; /* narrow strip like design */
  min-width: 120px;
  background: linear-gradient(rgba(20,184,166,0.7), rgba(20,184,166,0.7)),
              url("https://images.unsplash.com/photo-1503676260728-1c00da094a0b");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* PERFECT vertical text */
.mv-left h1 {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-size: 36px;
  color: #ffffff;
  font-weight: bold;
  letter-spacing: 3px;
  margin: 0;
}
  /* 🔷 RIGHT SLIDER */
.mv-slider {
  width: 350px;
  min-width: 150px;
  background: linear-gradient(rgba(59,130,246,0.7), rgba(59,130,246,0.7)),
              url("https://images.unsplash.com/photo-1524995997946-a1c2e315a42f");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
}

/* SLIDE CONTENT */
.slider-box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-box h2 {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  color: #fff;
  font-size: 28px;
  letter-spacing: 2px;
}

        /* 🔷 RIGHT SIDE */
        .mv-right {
          flex: 2;
          background: #f8fafc;
          padding: 60px 50px;
        }

        /* 🔷 ITEM */ 
        .mv-item { 
        display: flex; 
        align-items: flex-start; 
        margin-bottom: 35px; 
        gap: 15px;  
        }

       

  /*  ICON CIRCLE */
 .mv-icon {
  width: 90px;
  height: 90px;
  min-width: 90px; 
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #1e3a8a;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

/* FIXED IMAGE */
.mv-icon img {
  width: 114%;
  height: 114%;
  object-fit: cover;
}

        /* TEXT */
        .mv-item h3 {
          margin: 0;
          color: #1E3A8A;
        }

        .mv-item p {
          margin-top: 5px;
          color: #555;
        }

        /* 🔷 HIGHLIGHTS TITLE */
.highlight-title {
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
}

/* CONTAINER */
.highlight-container {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

/* CARD */
.highlight-card {
  display: flex;
  align-items: center;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

/* LEFT CURVED IMAGE */
.highlight-image {
  width: 250px;
  height: 200px;
  overflow: hidden;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.highlight-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* RIGHT CONTENT */
.highlight-content {
  padding: 20px;
  flex: 1;
}

.highlight-content h3 {
  margin: 0;
  color: #1e3a8a;
}

.highlight-content p {
  margin-top: 8px;
  color: #555;
}

.highlight-list {
  margin-top: 10px;
  padding-left: 20px;
  color: #555;
}

.highlight-list li {
  margin-bottom: 6px;
  line-height: 1.5;
  position: relative;
}

/* Optional: custom bullet style */
.highlight-list li::marker {
  color: #1e3a8a;
  font-weight: bold;
}

/* 🔷 RESPONSIVE */
@media (max-width: 768px) {
  .highlight-card {
    flex-direction: column;
  }

  .highlight-image {
    width: 100%;
    height: 180px;
    border-radius: 0;
  }
}

        /* 🔷 RESPONSIVE */
        
     @media (max-width: 768px) {
  .mv-wrapper {
    flex-direction: column;
  }

  .mv-left,
  .mv-slider {
    width: 100%;
    height: 120px;
  }

  .slider-box h2,
  .mv-left h1 {
    writing-mode: horizontal-tb;
    transform: none;
  }
}
      `}</style>

      <div className="home">

        {/* 🔷 BANNER */}
        <div className="banner">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            loop={true}
          >
            <SwiperSlide>
              <div className="banner-overlay">
                <img src={Banner1} alt="Banner 1" className="banner-img" />
                <div className="banner-text">
                  <h2>Welcome to Our School</h2>
                  <p>Building Future Leaders</p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="banner-overlay">
                <img src={Banner2} alt="Banner 2" className="banner-img" />
                <div className="banner-text">
                  <h2>Excellence in Education</h2>
                  <p>Empowering Students Everyday</p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        {/* 🔷 HERO */}
        <div className="hero">
          <h1>Welcome to our School Management System</h1>
          <p>
            Our school is dedicated to providing quality education and nurturing
            students to become responsible citizens and future leaders.
          </p>
        </div>

        {/* 🔷 MISSION & VISION */}
        <div className="section">
          <div className="mv-wrapper">

            {/* LEFT */}
            <div className="mv-left">
              <h1>Our Vision</h1>
            </div>

            {/* MIDDLE */}
            <div className="mv-right">
              <div className="mv-item">
                <div className="mv-icon">
                  <img src={VisionImg} alt="Vision" />
                </div>
                <div>
                  <h3>Vision</h3>
                  <p>To inspire and empower every student to achieve excellence and become responsible global citizens.</p>
                </div>
              </div>

              <div className="mv-item">
                <div className="mv-icon">
                  <img src={MissionImg} alt="Mission" />
                </div>
                <div>
                  <h3>Mission</h3>
                  <p>To provide quality education that nurtures creativity, values, and lifelong learning.</p>
                </div>
              </div>

              <div className="mv-item">
                <div className="mv-icon">
                  <img src={GoalImg} alt="Goal" />
                </div>
                <div>
                  <h3>Goals</h3>
                  <p>To develop academic excellence, leadership skills, and overall personality of every student.</p>
                </div>
              </div>
            </div>

            {/* 🔷 RIGHT SLIDER */}
            <div className="mv-slider">
              <Swiper
                modules={[Pagination, Autoplay]}
                pagination={{ clickable: true }}
                autoplay={{ delay: 2500 }}
                loop={true}
              >
                <SwiperSlide>
                  <div className="slider-box">
                    <h2>Achievement</h2>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="slider-box">
                    <h2>Activities</h2>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="slider-box">
                    <h2>Events</h2>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>


          </div>
          {/* 🔷 HIGHLIGHTS */}
          <div className="section">
            <h2 className="highlight-title">Highlights</h2>

            <div className="highlight-container">

              {/* 🔹 ITEM 1 */}
              <div className="highlight-card">
                <div className="highlight-image">
                  <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f" alt="News" />
                </div>
                <div className="highlight-content">
                  <h3>News</h3>
                  <ul className="highlight-list">
                    <li>Latest school updates</li>
                    <li>Events and activities</li>
                    <li>Important developments</li>
                  </ul>
                </div>
              </div>

              {/* 🔹 ITEM 2 */}
              <div className="highlight-card">
                <div className="highlight-image">
                  <img src="https://images.unsplash.com/photo-1509062522246-3755977927d7" alt="Achievement" />
                </div>
                <div className="highlight-content">
                  <h3>Achievement</h3>
                  <ul className="highlight-list">
                    <li>Student achievements</li>
                    <li>Academic excellence</li>
                    <li>Competition winners</li>
                  </ul>
                </div>
              </div>

              {/* 🔹 ITEM 3 */}
              <div className="highlight-card">
                <div className="highlight-image">
                  <img src="https://images.unsplash.com/photo-1497493292307-31c376b6e479" alt="Announcement" />
                </div>
                <div className="highlight-content">
                  <h3>Announcement</h3>
                  <ul className="highlight-list">
                    <li>Important notices</li>
                    <li>Exam schedules</li>
                    <li>Holiday updates</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>


        </div>

      </div>
    </>
  );
};

export default Home;